import { createRoot } from "react-dom/client";
import {useState, useEffect, useRef} from "react";
import List from '@/react/libraries/ButtonList/List';
import Dropdown from '@/react/libraries/Dropdown/Dropdown';
import Table from './components/Table';
import axios from "axios";


const Page = ({ payload }) => {

    const { dataClassFromServer, msid, countryId, stateId, org, scheduleType, logoPath, orgProfileUrl, userRole, countryList, header, schedule, types, url } = payload;

	const [type,setType] = useState(types[0].value);
    const [headers, setHeaders] = useState([])
	const [list, setList] = useState(dataClassFromServer[0]);
	const [data, setData] = useState([]);
	const [jurisdictionObj, setJurisdictionObj] = useState(countryId !== null ? { country: countryId } : { state: stateId });
	const [loading, setLoading] = useState(false);
	const typeDropdownRef = useRef(null);
	const [isHeaderLoaded, setIsHeaderLoaded] = useState(false)

	useEffect(()=> {
		if (typeDropdownRef.current) {
			// initialize dropdown
			const dropdown =  new MultiLayerDropdown(typeDropdownRef.current, {
				searchPlaceholder: 'Select Localisation',
				levels: [''],
				keys: ['localizations'],
				multiSelect: false,
			});

			(types.length < 2) ? typeDropdownRef.current.setAttribute('disabled', 'true') : ''; 

			typeDropdownRef.current.addEventListener('itemSelect', (e) => { 
				setType(e.detail.value);
			})

			dropdown.initializeData(types);

			// select the first item
			dropdown.selectItems({
				'localizations': [types[0].value]
			});
		}
	}, [])

    useEffect(() => {
    	const fetchHeaders = axios.get(`${url}?type=${type}&msid=${msid}`, {
		    headers: window.HEADER_OBJ
		});

    	let key = Object.keys(jurisdictionObj)[0];
    	let val = jurisdictionObj[key];

        const fetchJurisdiction = axios.get(`${API_URL}business-function?msid=${msid}&primary_filter=${list}&${key}_id=${val}&type=${type}`, {
		    headers: window.HEADER_OBJ
		});

		setLoading(true);
		Promise.all([fetchHeaders, fetchJurisdiction])
			.then(([headersRes, jurisdictionRes]) => {
		    	setHeaders(headersRes.data);
		    	setData(jurisdictionRes.data);
		      	setLoading(false);
			})
			.catch((err) => {
		      	console.log(err);
		      	setLoading(false);
		    });
    },[jurisdictionObj, list, type, isHeaderLoaded])

	const handleClick =(name)=>{
		setList(name);
	};

	const handleItemClick=(obj)=>{
		setJurisdictionObj(obj)
	}


	return (
		<div className="flex gap-5 mx-2 xl:mx-0">
			<div className="page-card px-5 max-w-[340px]">
				{
                    (org.publish_ms_settings !== null) &&  org.publish_ms_settings.display_logo_on_bf ?
					<div>
						<img className="max-h-[100px] h-full" src={logoPath} />
						<hr className="mt-4"/>
					</div> : (userRole === "Company Admin" ? <div>
							<p className="text-label">No logo found, please upload your logo and enable display logo from your <a className="text-primary hover:underline" href={orgProfileUrl}>Company profile</a></p>
							<hr className="mt-4"/>
						</div>
						: "")
				}

				<h2 className="text-sub2 font-medium mb-4 relative before:absolute before:w-24 before:h-1 leading-7 before:bg-primary before:rounded-primary before:-bottom-3">Business function</h2> 
			 	<div className={`${loading ? "cursor-wait pointer-events-none sticky top-4 max-h-[90vh] overflow-hidden" : "sticky top-4 max-h-[90vh] overflow-hidden"}`}>
			 		<List name={list} onButtonClick={handleClick} data={dataClassFromServer}/>
			 	</div>
			</div>
			<div className="page-card gap-4 min-w-min w-full">
				<div className="flex items-center justify-between">
					<div className="flex gap-1 items-center">
						{/*<p className="text-label text-grey font-medium mb-3">{schedule.name}</p>*/}
						{/*<h2 className="page-title text-sub2 flex gap-1 items-center"><span>{list}</span> <span className="text-lg text-grey-text">|</span><span className="text-label font-medium self-center text-grey-text"> Retention periods</span></h2>*/}
						<h2 className="page-title text-sub2 whitespace-nowrap">{list}</h2>
						<span className="text-lg text-grey-text">|</span>
						<span className="text-label font-medium self-center text-grey-text whitespace-nowrap"> Retention periods</span>
					</div>
					<div className={`flex gap-3 ${loading ? "cursor-wait pointer-events-none" : ""}`}>
						<div ref={typeDropdownRef}></div>
						<Dropdown selectItem={handleItemClick} countryList={countryList} jurisdictionObj={jurisdictionObj}/>
					</div>
				</div>
		        <div className="fk-table-alt">
					<Table data={data} isLoading={loading} headers={headers} list={list}/>
		        </div>
			</div>
		</div>
	)
}

function initPage(selector, payload) {
	createRoot(document.querySelector(selector)).render(
		<Page payload={payload} />
	);
}

export default initPage;
